// extracted by mini-css-extract-plugin
export default {"carousel":"lH-z"};